import { render, staticRenderFns } from "./My_Score_Dtl.vue?vue&type=template&id=5f6acaf9&scoped=true"
import script from "./My_Score_Dtl.vue?vue&type=script&lang=js"
export * from "./My_Score_Dtl.vue?vue&type=script&lang=js"
import style0 from "./My_Score_Dtl.vue?vue&type=style&index=0&id=5f6acaf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6acaf9",
  null
  
)

export default component.exports